import React, { Fragment } from "react";
import { ToastContainer } from "react-toastify";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./index.scss";
import Loader from "./layouts/Loader/Loader";
import Auth from "./Authentication/auth";
import { Provider } from "react-redux";
import store from "./Redux/store";
import EditOffer from "./components/Offers/edit";
// Destinations
const Destinations = React.lazy(() =>
  import("./components/Destinations/Destinations")
);

//Agent
const Agent = React.lazy(() => import("./components/Website/Agent"));
const AgentCooperators = React.lazy(() =>
  import("./components/TravelAgenciesCooperators/AgentCooperators")
);

const AgentOffers = React.lazy(() =>
  import("./components/Website/AgentOffers")
);

// Services
const Services = React.lazy(() => import("./components/Services/ServicePage"));

const Packages = React.lazy(() => import("./components/Packages/Packages"));

const TourOffers = React.lazy(() =>
  import("./components/CreateOffer/TourOffers")
);

const Reservations = React.lazy(() =>
  import("./components/Reservations/Reservations")
);

const TransportationTypes = React.lazy(() =>
  import("./components/TransportationType/TransportationTypes")
);
const PackageTitles = React.lazy(() =>
  import("./components/PackageTitles/PackageTitles")
);

const Amenities = React.lazy(() => import("./components/Amenities/Amenities"));

const TourguidePrices = React.lazy(() =>
  import("./components/TourguidePrice/TourguidePrices")
);

const TourProfitMatrix = React.lazy(() =>
  import("./components/ProfitPriceList/TourProfitMatrix")
);

const TourOperatorPriceMatrix = React.lazy(() =>
  import("./components/ProfitPriceList/OperatorPricesMatrix")
);

const CooperatorPrices = React.lazy(() =>
  import("./components/ProfitPriceList/CooperatorPricesPage")
);

const TransportationPrices = React.lazy(() =>
  import("./components/TransportationPrice/TransportationPrices")
);

const RoomCategories = React.lazy(() =>
  import("./components/RoomCategories/RoomCategories")
);
//Rols And Permissions
const Rols = React.lazy(() => import("./components/RolsPermissions/Rols"));
// Cooperators
const Cooperators = React.lazy(() =>
  import("./components/Cooperators/Cooperators")
);
// Leads
const Leads = React.lazy(() => import("./components/Leads/Leads"));

const Analytics = React.lazy(() =>
  import("./components/Leads/Members/Analytics")
);
const Campaigns = React.lazy(() =>
  import("./components/Leads/Campaigns/Campaigns")
);
const TravelAgencies = React.lazy(() =>
  import("./components/TravelAgency/Agencies")
);
const ColdCampaigns = React.lazy(() =>
  import("./components/Leads/ColdCampaigns/ColdCampaigns")
);
const LeadStatus = React.lazy(() =>
  import("./components/Leads/LeadStatus/LeadStatus")
);

const LeadsCalender = React.lazy(() => import("./components/Leads/Calendar"));
// Tour Operators
const TourLabels = React.lazy(() =>
  import("./components/TourLabel/TourLabels")
);

const AgentLabels = React.lazy(() =>
  import("./components/Agent_Label/AgentLabels")
);

const Countries = React.lazy(() => import("./components/Countries/Countries"));

const Accommodations = React.lazy(() =>
  import("./components/TourOperator/Accommodations/Accommodations")
);

const HotelManagement = React.lazy(() =>
  import("./components/Hotel/HotelManagement")
);

const RoomsCategory = React.lazy(() =>
  import("./components/Hotel/RoomsCategory")
);

const PricePlan = React.lazy(() => import("./components/Hotel/PricePlan"));

const BlockRooms = React.lazy(() => import("./components/Hotel/BlockRooms"));

const DayTours = React.lazy(() =>
  import("./components/TourOperator/DayTours/DayTours")
);

const Drivers = React.lazy(() =>
  import("./components/TourOperator/Drivers/Drivers")
);

const Tourguides = React.lazy(() =>
  import("./components/TourOperator/Tourguides/Tourguides")
);

//Offers
const CreateOffer = React.lazy(() => import("./components/Offers/create"));
const AllOffers = React.lazy(() => import("./components/Offers/AllOffers"));
const EditOffers = React.lazy(() => import("./components/Offers/edit"));
const AllMyOffers = React.lazy(() =>
  import("./components/Offers/MyPackages/AllMyOffers")
);
const PackageOffers = React.lazy(() =>
  import("./components/Offers/MyPackages/PackageOffers")
);
const CreateReservation = React.lazy(() =>
  import("./components/Offers/Reservation/CreateReservation")
);

//Reservation
const AllReservedTours = React.lazy(() =>
  import("./components/Offers/ReservedTours/AllReservedTours")
);
const Calendar = React.lazy(() =>
  import("./components/Offers/ReservedTours/Calendar")
);
const ReservationsAccountants = React.lazy(() =>
  import("./components/Offers/ReservedTours/ReservarionsAccountants")
);
const ReservationView = React.lazy(() =>
  import("./components/Offers/ReservedTours/ReservationView")
);
const DriverReservation = React.lazy(() =>
  import("./components/Offers/ReservedTours/DriverReservation")
);
const TourguideReservation = React.lazy(() =>
  import("./components/Offers/ReservedTours/TourguideReservation")
);
const HotelReservation = React.lazy(() =>
  import("./components/Offers/ReservedTours/HotelReservation")
);

const GuestName = React.lazy(() =>
  import("./components/Offers/ReservedTours/GuestName")
);
const DriverTour = React.lazy(() =>
  import("./components/Offers/ReservedTours/DriverTour")
);

const Dashboard = React.lazy(() => import("./components/Dashboard/Dashboard"));
const App = React.lazy(() => import("./components/app"));
// AdvanceUi
const Themepage = React.lazy(() => import("./components/Themepage"));

const Width = React.lazy(() => import("./components/Utilities/Width/Width"));
// coustom pages
const Error505 = React.lazy(() =>
  import("./components/Custompages/Error-505/Error-505")
);
const Error404 = React.lazy(() =>
  import("./components/Custompages/Error1-404/Error-404")
);

const Lockscreen = React.lazy(() =>
  import("./components/Custompages/Lockscreen/Lockscreen")
);

const Custompage = React.lazy(() => import("./components/Custompage"));
const Underconstructionpage = React.lazy(() =>
  import("./components/UnderConstruction")
);

const AuthLogin = React.lazy(() => import("./Authentication/Login"));
const ForgetPassword = React.lazy(() =>
  import("./Authentication/ForgetPassword")
);
const ResetPassword = React.lazy(() =>
  import("./Authentication/ResetPassword")
);

// My Profile
const Account = React.lazy(() => import("./components/MyProfile/Account"));

// Hotel
const HotelReservations = React.lazy(() =>
  import("./components/Hotel/AllHotelReservations")
);

// Driver
const DriverReservations = React.lazy(() =>
  import("./components/Driver/AllDriverReservations")
);

// Tourguide
const TourguideReservations = React.lazy(() =>
  import("./components/Tourguide/AllTourguideReservations")
);

const Root = () => {
  return (
    <Fragment>
      <BrowserRouter>
        <React.Suspense fallback={<Loader />}>
          <Routes>
            {/* Auth */}
            <Route path={`/`} element={<Auth />}>
              <Route index element={<AuthLogin />} />
              <Route path={`/login`} element={<AuthLogin />} />
              <Route path={`/forget-password`} element={<ForgetPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
            </Route>

            {/* App */}
            <Route path={`/`} element={<App />}>
              {/* offer & Reservations */}
              <Route>
                <Route path={`/all-offers`} element={<AllOffers />} />
                <Route path={`/edit-offer/:id`} element={<EditOffer />} />
                <Route path={`/all-my-packages`} element={<AllMyOffers />} />
                <Route
                  path={`/all-my-packages/offers/:id`}
                  element={<PackageOffers />}
                />
                <Route path={`/create-offer`} element={<CreateOffer />} />
                <Route path={`/edit-offer/:id`} element={<EditOffers />} />
                <Route
                  path={`/edit-reserved-offer/:id`}
                  element={<EditOffers />}
                />
                <Route path={`tour-offers`} element={<TourOffers />} />
                <Route path={`destinations`} element={<Destinations />} />
                <Route path={`services`} element={<Services />} />
                <Route path={`packages`} element={<Packages />} />

                <Route path={`agent`} element={<Agent />} />
                <Route path={`agent-offers`} element={<AgentOffers />} />
                <Route
                  path={`agent-cooperators`}
                  element={<AgentCooperators />}
                />

                <Route
                  path={`create-reservation/:id`}
                  element={<CreateReservation />}
                />

                <Route path={`all-reservations`} element={<Reservations />} />
                <Route
                  path={`edit-reservation/:id`}
                  element={<CreateReservation />}
                />

                <Route path={`/calendar`} element={<Calendar />} />
                <Route
                  path={`/accountants`}
                  element={<ReservationsAccountants />}
                />
                <Route
                  path={`/reservation-view/:id`}
                  element={<ReservationView />}
                />
                <Route
                  path={`/driver-reservation/:id`}
                  element={<DriverReservation />}
                />
                <Route
                  path={`/tourguide-reservation/:id`}
                  element={<TourguideReservation />}
                />
                <Route
                  path={`/hotel-reservation/:id`}
                  element={<HotelReservation />}
                />
                <Route path={"/dashboard/"} element={<Dashboard />} />
              </Route>
              {/* Tour Operators */}
              <Route path="tour-operator">
                <Route path="accommodations" element={<Accommodations />} />

                <Route path="dayTours" element={<DayTours />} />
                <Route path="drivers" element={<Drivers />} />

                <Route path="tourguides" element={<Tourguides />} />
              </Route>
              {/* My Profile */}
              <Route path="my-account" element={<Account />} />
              {/* Leads */}
              <Route path="leads" element={<Leads />} />

              <Route path="analytics" element={<Analytics />} />
              <Route path="campaigns" element={<Campaigns />} />
              <Route path="travel-agencies" element={<TravelAgencies />} />
              <Route path="cold-campaigns" element={<ColdCampaigns />} />
              <Route path="lead-status" element={<LeadStatus />} />
              <Route path="leads-calender" element={<LeadsCalender />} />
              {/* Tour Labels */}
              <Route path="tour-labels" element={<TourLabels />} />
              <Route path="agent-labels" element={<AgentLabels />} />
              <Route path="countries" element={<Countries />} />
              {/* Room Categories */}
              <Route path="room-categories" element={<RoomCategories />} />
              {/* Transportation Prices */}
              <Route
                path="transportation-prices"
                element={<TransportationPrices />}
              />
              {/* Tourguide Prices */}
              <Route path="tourguide-prices" element={<TourguidePrices />} />
              {/* Profit Prices */}
              <Route path="profit-prices" element={<TourProfitMatrix />} />

              {/* Tour Operator Prices */}
              <Route
                path="tour-operator-prices"
                element={<TourOperatorPriceMatrix />}
              />
              {/* Cooperators Prices */}
              <Route path="cooperator-prices" element={<CooperatorPrices />} />
              {/* Transportation Types */}
              <Route
                path="transportation-types"
                element={<TransportationTypes />}
              />
              {/* Package titles  */}
              <Route path="package-titles" element={<PackageTitles />} />
              {/* Cooperators */}
              {/* Aminities  */}
              <Route path="amenities" element={<Amenities />} />
              <Route path="cooperators" element={<Cooperators />} />
              {/* Rols And Permissions */}
              <Route path="rols-permissions" element={<Rols />} />
              {/* Hotel */}
              <Route
                path="hotel-reservations"
                element={<HotelReservations />}
              />
              <Route path={`hotel-management`} element={<HotelManagement />} />
              <Route
                path={`hotel-rooms-category`}
                element={<RoomsCategory />}
              />
              <Route path={`hotel-price-list`} element={<PricePlan />} />
              <Route path={`hotel-block-rooms`} element={<BlockRooms />} />
              {/* Driver */}
              <Route
                path="driver-reservations"
                element={<DriverReservations />}
              />
              {/* Tourguide */}
              <Route
                path="tourguide-reservations"
                element={<TourguideReservations />}
              />
            </Route>

            <Route
              path={`${process.env.PUBLIC_URL}/pages/switcherpages`}
              element={<Themepage />}
            />
            {/* ........................................Custompage............................................... */}
            <Route path={`${process.env.PUBLIC_URL}/`} element={<Custompage />}>
              {/* custompages */}
              {/* Errors */}
              <Route
                path={`${process.env.PUBLIC_URL}/custompages/error404`}
                element={<Error404 />}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/custompages/lockscreen`}
                element={<Lockscreen />}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/custompages/error505`}
                element={<Error505 />}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/custompages/underconstruction`}
                element={<Underconstructionpage />}
              />
            </Route>

            <Route path={`/guest-name/:id`} element={<GuestName />} />
            <Route path={`/driver-tour/:id`} element={<DriverTour />} />
            {/* ........................................Errorpage............................................... */}
            <Route path="*" element={<Error404 />} />
          </Routes>
        </React.Suspense>
      </BrowserRouter>
    </Fragment>
  );
};
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    {/* <ErrorBoundary> */}
    <Root />
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
      style={{ zIndex: 999999 }} // <-- THE FIX IS HERE
    />
    {/* </ErrorBoundary> */}
  </Provider>
);
